import { Component } from "@angular/core";

@Component({
  selector: 'made-in-vienna',
  templateUrl: './made-in-vienna.component.html',
  styleUrls: ['./made-in-vienna.component.scss'],
})
export class MadeInViennaComponent {

}